import { requestHandler } from '../utils/api';

export type OEmbedMeta = {
  html: string;
  url: string;
  width: number;
  height: string | null;
};

export const fetchOEmbedMeta = async (
  api: string,
  url: string,
  apiUrl: string,
): Promise<OEmbedMeta> => {
  const { data } = await requestHandler({
    url: `${apiUrl}/meta/scrap/oembed?api=${api}&url=${url}`,
    withCredentials: false,
  });

  return data;
};
